import templateUrl from './rogers-hybrid-payout-report-container.component.html';
import { IQService } from 'angular';
import { UtilityService } from '../../../../../core/services/utility.service';
import { EmployeeService } from '../../../../../core/services/data-services/employee.service';

export const RogersHybridPayoutReportComponent = {
    controller: RogersHybridPayoutReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        filteredWorkOrderPayouts: '<'
    }
};

function RogersHybridPayoutReportController($q: IQService, apexApiUrl: string,
    employeeService: EmployeeService, divisionService, icdCorporationService,
    rogersPayoutReportService, utilityService: UtilityService) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.filters = {};
    vm.icdCorporations;
    vm.onExport = onExport;
    vm.onRefreshData = onRefreshData;
    vm.showFilters = true;
    vm.workOrderPayouts;
    vm.productLines;
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.filteredWorkOrderPayouts;
    vm.icdCorporationPageSize = 2000;

    function onInit() {
        const initialDataLoaded = loadInitialData();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(initialDataLoaded, "Initial load failed"));
    }


    function onRefreshData() {

        $q.when(utilityService.showLoading())
            .then(loadWorkOrderPayouts)
            .catch(function (ex) {
                alert(`Initial load failed: ${utilityService.getExceptionMessage(ex)}`);
            })
            .then(utilityService.hideLoading);

    }

    function onExport() {
        const query: any = {
            DivisionID: divisionService.divisionIDs.Rogers,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
            StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
            EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
        };
        if (vm.filters.hidePosted) {
            query.showPosted = false;
        }
        const queryString = utilityService.queryStringify(query);
        window.location.href = apexApiUrl + "reports/rogers/hybrid-payout-report.xlsx" + queryString;
    }

    function loadInitialData() {
        const identity = employeeService.retrieveIdentity()
        const icdCorporationsLoaded = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
            divisionID: divisionService.divisionIDs.Rogers
        });
        $q.all([identity, icdCorporationsLoaded])
            .then(([identity, icdCorporations]) => {
                vm.isSiteAdmin = identity.IsSiteAdmin;
                vm.icdCorporations = icdCorporations;
                if (!identity.IsSiteAdmin) {
                    vm.filters.IcdCorporation = icdCorporations[0]; // Not nullable.
                }
                vm.icdCorporations.forEach(formatIcdCorporation);
                vm.icdCorporations.sort(function (a, b) {
                    return a.OwnerClientName < b.OwnerClientName ? -1 : 1;
                });
                return icdCorporations;
            });

        return $q.all([icdCorporationsLoaded]);
    }

    function loadWorkOrderPayouts() {
        const query: any = {
            DivisionID: divisionService.divisionIDs.Rogers,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null,
            StartDate: vm.filters.StartDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.StartDate) : null,
            EndDate: vm.filters.EndDate ? kendo.format("{0:yyyy-MM-dd}", vm.filters.EndDate) : null
        };
        if (vm.filters.hidePosted) {
            query.showPosted = false;
        }

        return rogersPayoutReportService.retrieveRogersHybridPayoutReport(query)
            .then(function (payoutReport) {
                vm.payoutReport = payoutReport;
                return payoutReport;
            });
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }
}
